import codes from './modules/codes';

import layoutHeaderAside from '@/layout/header-aside';

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: { name: 'index' },
    component: layoutHeaderAside,
    children: [
      // 首页 必须 name:index
      {
        path: 'index',
        name: 'index',
        meta: {
          auth: true,
          title: '酒店管理'
        },
        component: () => import('@/pages/index')
      },
      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: {
          beforeRouteEnter (to, from, next) {
            next(vm => vm.$router.replace(from.fullPath));
          },
          render: h => h()
        }
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: {
          beforeRouteEnter (to, from, next) {
            next(vm => vm.$router.replace(JSON.parse(from.params.route)));
          },
          render: h => h()
        }
      },
      {
        path: '/staff',
        name: 'staff',
        meta: { auth: true, title: '员工管理' },
        component: () => import('@/pages/staff')
      },
      {
        path: '/product',
        name: 'product',
        meta: { auth: true, title: '产品功能管理' },
        component: () => import('@/pages/product')
      },
      {
        path: '/feedbacks',
        name: 'feedbacks',
        meta: { auth: true, title: '客户反馈', checkAuth: true },
        component: () => import('@/pages/feedbacks')
      },
      {
        path: '/logs',
        name: 'logs',
        meta: { auth: true, title: '日志管理' },
        component: () => import('@/pages/logs')
      },
      {
        path: '/agents',
        name: 'agents',
        meta: { auth: true, title: '代理商管理', checkAuth: true },
        component: () => import('@/pages/agents')
      },
      {
        path: '/analytics',
        name: 'analytics',
        meta: { auth: true, title: '业绩报表', checkAuth: true },
        component: () => import('@/pages/analytics')
      },
      {
        path: '/report',
        name: 'report',
        meta: { auth: true, title: '统计报表', checkAuth: true },
        component: () => import('@/pages/report')
      },
      {
        path: '/setting',
        name: 'setting',
        meta: { auth: true, title: '高级设置' },
        component: () => import('@/pages/setting')
      },
      {
        path: '/hotel',
        name: 'hotel',
        meta: { auth: true, title: '酒店小程序管理' },
        component: () => import('@/pages/hotel')
      },
      {
        path: '/end-points',
        name: 'end-points',
        meta: { auth: true, title: '酒店终端管理' },
        component: () => import('@/pages/end-points')
      },
      {
        path: '/super-logs',
        name: 'super-logs',
        meta: { auth: true, title: '服务器日志' },
        component: () => import('@/pages/super-logs')
      }
    ]
  },
  codes
];

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login')
  }
];

/**
 * 错误页面
 */
const errorPage = [
  // 404
  {
    path: '*',
    name: '404',
    component: () => import('@/pages/error-page-404')
  }
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
];
